import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { TimePicker, LocalizationProvider, } from '@mui/x-date-pickers';
import { WEEK_DAYS } from "constants";
import { Clear } from "@mui/icons-material";
import { Box, Button, Divider, Grid, IconButton, InputAdornment, Typography } from "@mui/material";
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

export default function WorkHours({ workhours, handleChange, validationErrors, onSetWholeWeek }) {
    const { t } = useTranslation()
    const [week, setWeek] = useState([null, null])

    return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
            <Grid item xs={12} md={12} sx={{ mb: 10 }}>
                <Grid container spacing={10} justifyContent="space-between" alignItems="center">
                    <Grid item md={3} sm={2} xs={2}>
                        <Typography sx={{ fontWeight: "bold" }}>
                            {t("The whole week")}
                        </Typography>
                    </Grid>
                    <Grid item md={3} sm={4} xs={5}>
                        <TimePicker
                            name="workhours"
                            label={t("From")}
                            value={week[0]}
                            onChange={(value) => setWeek(prev => ([value, prev[1]]))}
                            size="small"
                            fullWidth
                            variant="outlined"
                            margin="dense"
                            slotProps={{
                                textField: (params) => {
                                    return {
                                        fullWidth: true,
                                        size: "small",
                                        margin: "dense",
                                        InputProps: {
                                            ...params?.InputProps,
                                            startAdornment: !!week[0] ?
                                                <InputAdornment position="start">
                                                    <IconButton onClick={(event) => {
                                                        event.stopPropagation()
                                                        setWeek(prev => ([null, prev[1]]))
                                                    }} size='small' color='primary'>
                                                        <Clear sx={{ fontSize: "inherit" }} />
                                                    </IconButton>
                                                </InputAdornment> : ''
                                        },
                                    }
                                }
                            }}
                        />
                    </Grid>
                    <Grid item md={3} sm={4} xs={5}>
                        <TimePicker
                            name="workhours"
                            label={t("To")}
                            value={week[1]}
                            onChange={(value) => setWeek(prev => ([prev[0], value]))}
                            size="small"
                            fullWidth
                            variant="outlined"
                            margin="dense"
                            slotProps={{
                                textField: (params) => {
                                    return {
                                        fullWidth: true,
                                        size: "small",
                                        margin: "dense",
                                        InputProps: {
                                            ...params?.InputProps,
                                            startAdornment: !!week[1] ?
                                                <InputAdornment position="start">
                                                    <IconButton onClick={(event) => {
                                                        event.stopPropagation()
                                                        setWeek(prev => ([prev[0], null]))
                                                    }} size='small' color='primary'>
                                                        <Clear sx={{ fontSize: "inherit" }} />
                                                    </IconButton>
                                                </InputAdornment> : ''
                                        },
                                    }
                                }
                            }}
                        />
                    </Grid>
                    <Grid item md={3} sm={4} xs={5}>
                        <Box display="flex" alignItems="center" justifyContent="end">
                            <Button disabled={week.includes(null)} onClick={() => onSetWholeWeek(week)} sx={{ textTransform: "none" }} size='small' variant='contained'>
                                {t("Set")}
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
                <Box sx={{my: 20}} />
                {WEEK_DAYS.map((day, dayIndex) => (
                    <Grid key={day} container spacing={10} alignItems="center">
                        <Grid item md={3} sm={2} xs={2}>
                            <Typography sx={{ fontWeight: "bold" }}>
                                {t(day)}
                            </Typography>
                        </Grid>
                        <Grid item md={3} sm={4} xs={5}>
                            <TimePicker
                                name="workhours"
                                label={t("From")}
                                value={workhours[dayIndex] ? workhours[dayIndex][0] : null}
                                onChange={(value) => handleChange({ target: { name: "workhours", value, day: dayIndex, label: "from" } })}
                                size="small"
                                fullWidth
                                variant="outlined"
                                margin="dense"
                                slotProps={{
                                    textField: (params) => {
                                        return {
                                            error: !!validationErrors?.workhours && !!validationErrors?.workhours[dayIndex],
                                            helperText: !!validationErrors?.workhours && !!validationErrors?.workhours[dayIndex] && t("Time from - to is required."),
                                            fullWidth: true,
                                            size: "small",
                                            margin: "dense",
                                            InputProps: {
                                                ...params?.InputProps,
                                                startAdornment: (!!workhours[dayIndex] && !!workhours[dayIndex][0]) ?
                                                    <InputAdornment position="start">
                                                        <IconButton onClick={(event) => {
                                                            event.stopPropagation()
                                                            handleChange({ target: { name: "workhours", value: null, day: dayIndex, label: "from" } })
                                                        }} size='small' color='primary'>
                                                            <Clear sx={{ fontSize: "inherit" }} />
                                                        </IconButton>
                                                    </InputAdornment> : ''
                                            },
                                        }
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item md={3} sm={4} xs={5}>
                            <TimePicker
                                name="workhours"
                                label={t("To")}
                                value={workhours[dayIndex] ? workhours[dayIndex][1] : null}
                                onChange={(value) => handleChange({ target: { name: "workhours", value, day: dayIndex, label: "to" } })}
                                size="small"
                                fullWidth
                                variant="outlined"
                                margin="dense"
                                slotProps={{
                                    textField: (params) => {
                                        return {
                                            error: !!validationErrors?.workhours && !!validationErrors?.workhours[dayIndex],
                                            helperText: !!validationErrors?.workhours && !!validationErrors?.workhours[dayIndex] && t("Time from - to is required."),
                                            fullWidth: true,
                                            size: "small",
                                            margin: "dense",
                                            InputProps: {
                                                ...params?.InputProps,
                                                startAdornment: (!!workhours[dayIndex] && !!workhours[dayIndex][1]) ?
                                                    <InputAdornment position="start">
                                                        <IconButton onClick={(event) => {
                                                            event.stopPropagation()
                                                            handleChange({ target: { name: "workhours", value: null, day: dayIndex, label: "to" } })
                                                        }} size='small' color='primary'>
                                                            <Clear sx={{ fontSize: "inherit" }} />
                                                        </IconButton>
                                                    </InputAdornment> : ''
                                            },
                                        }
                                    }
                                }}
                            />
                        </Grid>
                    </Grid>
                ))}
            </Grid>
        </LocalizationProvider>
    )
}
